module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/requisition-elite.a1b6ba97.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/requisition-elite.png
// module id = 3747
// module chunks = 11